import { configureStore } from '@reduxjs/toolkit';

import accountClientGroupReducer from 'Reducers/AccountClientGroups';
import accountPositionsReducer from 'Reducers/accountPositions';
import accountRelationshipsReducer from 'Reducers/accountRelationships';
import accountsReducer from 'Reducers/accounts';
import accountsWithdrawalRelationshipsReducer from 'Reducers/accountsWithdrawalRelationships';
import accountWithdrawalDataReducer from 'Reducers/accountWithdrawalData';
import acgUserReducer from 'Reducers/ACGUsers';
import alertsReducer from 'Reducers/alerts';
import apiBalanceStats from 'Reducers/apiBalanceStats';
import apiConnectionFirmReducer from 'Reducers/apiconnectionfirms';
import apiConnectionReducer from 'Reducers/apiconnections';
import apiConnectionUserReducer from 'Reducers/apiconnectionusers';
import assetBalanceStats from 'Reducers/assetBalanceStats';
import assetReducer from 'Reducers/assets';
import clientMessageReducer from 'Reducers/clientMessage';
import statisticsReducer from 'Reducers/dailyStatistics';
import feeReducer from 'Reducers/fees';
import firmApiType from 'Reducers/firmApiType';
import firmAssetBalanceStatsReducer from 'Reducers/firmAssetBalanceStats';
import firmAssetEntitlementsReducer from 'Reducers/firmAssetEntitlements';
import firmReducer from 'Reducers/firms';
import firmStatsReducer from 'Reducers/firmStats';
import killSwitchReducer from 'Reducers/kllSwitch';
import liquidityFacilityStatsReducer from 'Reducers/liquidityFacilityStats';
import netAssetValuesReducer from 'Reducers/netAssetValues';
import pcgUserReducer from 'Reducers/PCGUsers';
import pledgesReducer from 'Reducers/pledges';
import pricesReducer from 'Reducers/prices';
import privateClientGroupReducer from 'Reducers/PrivateClientGroups';
import transactionsReducer from 'Reducers/transactions';
import uiReducer from 'Reducers/ui';
import userReducer from 'Reducers/user';
import userAccountReducer from 'Reducers/userAccounts';
import userApiTypeReducer from 'Reducers/userApiTypes';
import usersReducer from 'Reducers/users';
import validationReducer from 'Reducers/validation';

const adminStore = configureStore({
    devTools: { name: 'Tassat - Admin' },
    reducer: {
        accounts: accountsReducer,
        accountPositions: accountPositionsReducer,
        accountClientGroups: accountClientGroupReducer,
        accountRelationships: accountRelationshipsReducer,
        accountsWithdrawalRelationships: accountsWithdrawalRelationshipsReducer,
        accountsWithdrawalData: accountWithdrawalDataReducer,
        acgUsers: acgUserReducer,
        alerts: alertsReducer,
        apiConnections: apiConnectionReducer,
        apiConnectionFirms: apiConnectionFirmReducer,
        apiConnectionUsers: apiConnectionUserReducer,
        firms: firmReducer,
        firmApiTypes: firmApiType,
        firmStats: firmStatsReducer,
        firmAssetBalanceStats: firmAssetBalanceStatsReducer,
        firmAssetEntitlements: firmAssetEntitlementsReducer,
        killSwitch: killSwitchReducer,
        pcgUsers: pcgUserReducer,
        privateClientGroups: privateClientGroupReducer,
        statistics: statisticsReducer,
        transactions: transactionsReducer,
        ui: uiReducer,
        user: userReducer,
        users: usersReducer,
        userAccounts: userAccountReducer,
        userApiTypes: userApiTypeReducer,
        validation: validationReducer,
        clientMessage: clientMessageReducer,
        assets: assetReducer,
        assetBalanceStats: assetBalanceStats,
        apiBalanceStats: apiBalanceStats,
        netAssetValues: netAssetValuesReducer,
        prices: pricesReducer,
        fees: feeReducer,
        liquidityFacilityStats: liquidityFacilityStatsReducer,
        pledges: pledgesReducer
    }
});

export type AdminState = ReturnType<typeof adminStore.getState>;
export type AdminDispatch = typeof adminStore.dispatch;

export default adminStore;